import React from "react";
import { FaMapMarkerAlt } from "react-icons/fa";

const SelectableBlockHome = ({
                             title,
                             titleAdditional,
                             address,
                             onSelect,
                             isSelected,
                             customClassH1,
                             customClassH2,
                             isLocalIconEnable= true,
                             classname="selectable-block" ,}) => {
    return (
        <div
            className={`${classname} ${isSelected ? "selected" : ""}`}
            onClick={() => onSelect(title)}

        >
            <h1 className={customClassH1}>{title}</h1>
            <h2 className={customClassH2}>{titleAdditional}</h2>
            {isLocalIconEnable && <FaMapMarkerAlt style={{fontSize: '25px'}}/>}
            <p>{address}</p>
        </div>
    );
};

export default SelectableBlockHome;